import { AppController } from "../AppController";
var BillingAddressPage = /** @class */ (function () {
    function BillingAddressPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(BillingAddressPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingAddressPage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingAddressPage.prototype, "availableCountries", {
        get: function () {
            return this.appController.availableCountries;
        },
        enumerable: true,
        configurable: true
    });
    return BillingAddressPage;
}());
export { BillingAddressPage };
